import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const rows = [
  { feature: 'Attendance Accuracy', manual: 'Prone to buddy punching', system: '100% biometric verified' },
  { feature: 'Payroll Processing Time', manual: '2-3 days of manual work', system: 'Under 5 minutes' },
  { feature: 'Compliance Reports', manual: 'Manual calculation risk', system: 'Auto-generated monthly' },
  { feature: 'Multi-branch Visibility', manual: 'Separate registers per branch', system: 'Unified dashboard' },
  { feature: 'Leave Tracking', manual: 'Paper forms, easy to lose', system: 'Digital with full audit trail' },
  { feature: 'Payslip Delivery', manual: 'Manual email or paper', system: 'Auto-emailed to all staff' },
];

const ComparisonTable = () => (
  <Box sx={{ py: { xs: 8, md: 12 }, background: 'linear-gradient(180deg, #030d1f 0%, #041828 100%)' }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 7 }}>
        <Typography sx={{ color: '#10b981', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>The Difference is Clear</Typography>
        <Typography variant="h2" sx={{ fontWeight: 800, color: '#fff', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.8rem', md: '2.6rem' } }}>
          Manual HR vs SN Info Systems
        </Typography>
      </Box>

      {/* Table Header */}
      <Box sx={{ bgcolor: 'rgba(255,255,255,0.04)', borderRadius: '16px 16px 0 0', p: 2, display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2, border: '1px solid rgba(255,255,255,0.08)' }}>
        <Typography sx={{ fontWeight: 800, color: '#94a3b8', fontSize: 13, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase', letterSpacing: 1 }}>Feature</Typography>
        <Typography sx={{ fontWeight: 800, color: '#ef4444', fontSize: 13, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase', letterSpacing: 1, textAlign: 'center' }}>❌ Manual Process</Typography>
        <Typography sx={{ fontWeight: 800, color: '#10b981', fontSize: 13, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase', letterSpacing: 1, textAlign: 'center' }}>✅ SN Info Systems</Typography>
      </Box>
      {rows.map((r, i) => (
        <Box key={i} sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2, p: 2, bgcolor: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', borderTop: 'none', ...(i === rows.length - 1 ? { borderRadius: '0 0 16px 16px' } : {}) }}>
          <Typography sx={{ color: '#cbd5e1', fontWeight: 600, fontFamily: "'Montserrat', sans-serif", fontSize: 14, display: 'flex', alignItems: 'center' }}>{r.feature}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CloseIcon sx={{ color: '#ef4444', fontSize: 18, flexShrink: 0 }} />
            <Typography sx={{ color: '#94a3b8', fontFamily: "'Montserrat', sans-serif", fontSize: 13 }}>{r.manual}</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CheckIcon sx={{ color: '#10b981', fontSize: 18, flexShrink: 0 }} />
            <Typography sx={{ color: '#d1fae5', fontFamily: "'Montserrat', sans-serif", fontSize: 13, fontWeight: 600 }}>{r.system}</Typography>
          </Box>
        </Box>
      ))}
    </Container>
  </Box>
);

export default ComparisonTable;
